import {
  infiniteQueryOptions,
  queryOptions,
  useMutation,
} from "@tanstack/react-query";
import {
  listLibrary,
  getMatterFileMoveSource,
  getLibraryContent,
  uploadLibraryFile,
  type LibraryScope,
} from "@/lib/data/requests/file-library";
export const libraryQueryKey = ["file-library"];
export const libraryQueryOptions = (scope: LibraryScope, parentId?: string) =>
  infiniteQueryOptions({
    queryKey: [...libraryQueryKey, scope, parentId],
    initialPageParam: undefined as string | undefined,
    queryFn: ({ pageParam }) => listLibrary(scope, parentId, pageParam),
    getNextPageParam: (page) => page.nextCursor ?? undefined,
  });
export const libraryContentQueryOptions = (id: string) =>
  queryOptions({
    queryKey: [...libraryQueryKey, "content", id],
    queryFn: () => getLibraryContent(id),
  });
export const useUploadPersonalFile = () =>
  useMutation({ mutationFn: (file: File) => uploadLibraryFile(file) });
export const matterFileMoveQueryOptions = (id: string) =>
  queryOptions({
    queryKey: [...libraryQueryKey, "matter-move", id],
    queryFn: () => getMatterFileMoveSource(id),
    staleTime: 0,
  });
